// extracted by mini-css-extract-plugin
export default {"modal":"RequestReview_modal__UHlDB","heading":"RequestReview_heading__k3jad","success-msg":"RequestReview_success-msg__sTJcQ"};